<template>
  <div class="daily-cargo-identity-check-sheet">
    <div class="row">
      <div class="col3">
        <form-label>Type</form-label>
        <form-filtered-select
          v-model="Flight_Type"
          :options="flightOptions"
          :selected-key="Flight_Type"
          @updateDropdownValue="filterDailyCargoDriverData(Flight_Type)" />
      </div>
      <div class="col3" style="padding-top: 20px;">
        <form-button
          v-if="Flight_Type === 'FKB - JKG'"
          :disabled="dailyCargoRacValidation.length < 1"
          @onClick="generateIdentityCheckSheet">
          FKB Anlieferung
        </form-button>
        <form-button
          v-if="Flight_Type === 'MHG - BLQ' || Flight_Type === 'FKB - BLQ'"
          :disabled="dailyCargoRacValidation.length < 1"
          @onClick="generateIdentityCheckSheet">
          BLQ Anlieferung
        </form-button>
        <form-button
          v-if="Flight_Type === 'MHG - LBG' || Flight_Type === 'FKB - LBG'"
          :disabled="dailyCargoRacValidation.length < 1"
          @onClick="generateIdentityCheckSheet">
          LBG Anlieferung
        </form-button>
        <form-button
          v-if="Flight_Type === 'MHG - MAD' || Flight_Type === 'FKB - MAD'"
          :disabled="dailyCargoRacValidation.length < 1"
          @onClick="generateIdentityCheckSheet">
          MAD Anlieferung
        </form-button>
      </div>
    </div>
    <table>
      <thead>
        <tr class="daily-cargo-identity-check-sheet__head">
          <th
            v-for="(header, index) in tableFields"
            :key="'dashboardPrecariageHeader' + index">
            <span />
            {{ header.label }}
          </th>
          <th />
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(dailyCargo, dailyCargoIndex) in filteredDailyCargoDriverData"
          :key="'dailyCargoTable' + dailyCargoIndex">
          <td
            v-for="(field, fieldIndex) in tableFields"
            :key="'dashboardPrecariageField' + dailyCargoIndex + '.' + fieldIndex"
            class="daily-cargo-identity-check-sheet__field">
            <span>
              {{ dailyCargo[field.name] }}
            </span>
          </td>
          <td>
            <form-button
              class="spl-daily-cargo-table__edit"
              @onClick="editData(dailyCargo)">
              <img src="../../../assets/icon-edit.svg">
            </form-button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Helpers from '@/helpers.vue'
import constants from '@/constants'

export default {
  mixins: [Helpers],
  data () {
    return {
      tableFields: [
        { name: 'Flight_Name', label: 'Flight_Name', type: 'String' },
        { name: 'Customer_Name', label: 'Customer_Name', type: 'String' },
        { name: 'Country_Name', label: 'Country_Name', type: 'String' },
        { name: 'Provider_Name', label: 'Provider Name', type: 'String' },
        { name: 'Transporter', label: 'Transporter', type: 'String' },
        { name: 'Vehicle_Name', label: 'Vehicle Type', type: 'String' },
        { name: 'License_Number', label: 'License_Number', type: 'String' },
        { name: 'Driver_Name', label: 'Driver_Name', type: 'String' },
        { name: 'Plate_Number', label: 'Plate_Number', type: 'String' },
        { name: 'Seal_Number_1', label: 'Seal Number 1', type: 'String' },
        { name: 'Seal_Number_2', label: 'Seal Number 2', type: 'String' }
      ],
      Flight_Type: 'FKB - JKG',
      Flight_ID: 0,
      filteredDailyCargoDriverData: [],
      flightOptions: [
        { value: 'FKB - JKG', label: 'FKB-JKG' },
        { value: 'MHG - BLQ', label: 'MHG-BLQ' },
        { value: 'MHG - LBG', label: 'MHG-LBG' },
        { value: 'MHG - MAD', label: 'MHG-MAD' },
        { value: 'FKB - BLQ', label: 'FKB-BLQ' },
        { value: 'FKB - LBG', label: 'FKB-LBG' },
        { value: 'FKB - MAD', label: 'FKB-MAD' }
      ],
      constants
    }
  },
  computed: {
    ...mapGetters('dailyCargo', ['dailyCargoIdentityCheckList', 'dailyCargoDriver', 'dailyCargoRacValidation'])
  },
  created () {
    this.loadDailyCargoIdentityCheckList().then(() => {
      this.filterDailyCargoDriverData(this.Flight_Type)
      if (this.filteredDailyCargoDriverData) {
        this.Flight_ID = this.filteredDailyCargoDriverData[0].Flight_ID
      }
    })
    this.loadDailyCargoIdentityCheckList()
  },
  methods: {
    ...mapActions('dailyCargo', ['loadDailyCargoIdentityCheckList', 'loadDailyCargoDriver']),
    editData (dailyCargo) {
      this.$router.push({ name: 'daily-cargo-edit-identity-check-sheet', params: dailyCargo })
    },
    filterDailyCargoDriverData (flightName) {
      this.filteredDailyCargoDriverData = this.dailyCargoIdentityCheckList.filter(a => a.Flight_Name === flightName)
      if (Array.isArray(this.filteredDailyCargoDriverData) && this.filteredDailyCargoDriverData.length > 0) {
        this.Flight_ID = this.filteredDailyCargoDriverData[0].Flight_ID
      }
    },
    generateIdentityCheckSheet () {
      this.generateManifestDocument(this.Flight_ID, 'IdentityCheckSheet.pdf', 'identity')
    }
  }
}
</script>
<style lang="scss">
  @import '../../../variables.scss';
  .daily-cargo-identity-check-sheet {
    width: 100%;
    height: calc(100vh - 205px);
    padding-bottom: 20px;
    overflow: auto;

    &__fields {
      display: grid;
      grid-template-columns: 19% 19% 19% 19% 19%;
      grid-gap: 7px;
      width: 100%;
      padding-top: 1%;
    }

    table {
      border-spacing: 0;
      table-layout: fixed;
      padding-bottom: 100px;
    }
    &__head {
      th {
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.2), 0 3px 5px 0 rgba(0, 0, 0, 0.1);
      }
      &--sticky {
        position: sticky;
        left: 41px;
        z-index: 3 !important;
      }
      &--checkbox {
        .spl-checkbox {
          margin: 10px 2px 0 6px;
        }
        position: sticky;
        left: 0px;
        z-index: 3 !important;
      }
    }
    &__row {
      &--selected {
        background-color: $tableRowBackgroundColorSelected !important;
      }
      &--deleted {
        opacity: 0.3;
        background-color: lightgrey !important;
      }
    }
    &__field {
      &--number {
        text-align: right;
        width: 70px;
      }
      &--sticky {
        position: sticky;
        left: 41px;
        box-shadow: 3px 0px 3px 0px rgba(0, 0, 0, 0.2);
        background-color: $tableHeaderBackgroundColor;
      }
      &--long {
        max-width: 400px !important;
        white-space: nowrap;
      }
      &--success {
        border-bottom: 2px solid $green !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $green;
      }
      &--warning {
        border-bottom: 2px solid $darkYellow !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $darkYellow;
      }
      &--error {
        border-bottom: 2px solid $red !important;
        padding-bottom: 3px !important;
        font-weight: 600;
        color: $red;
      }
      &--bold {
        font-weight: 600;
      }
      &--empty:hover {
        background-color: $tableRowBackgroundColorHover !important;
      }
    }
    thead {
      th {
        position: sticky;
        top: 0;
        text-align: left;
        font-family: $mono;
        font-size: 9px;
        font-weight: 700;
        text-transform: uppercase;
        letter-spacing: 1px;
        line-height: 12px;
        background-color: $tableHeaderBackgroundColor;
        padding: 0px 5px  0px 5px;
        height: 40px;
        border-bottom: 1px solid $tableHeaderBorderColor;
      }

      th:hover {
        background-color: $tableColumnBackgroundColorHover;
        cursor: pointer;
      }
    }
    tbody {
      tr {
        background-color: $tableRowBackgroundColor;
        &:nth-child(even) {
          background: $tableHeaderBackgroundColor;
        }
      }
      tr:hover {
        background-color: $tableRowBackgroundColorHover;
      }
      td {
        border-style: solid;
        border-width: 0 1px 1px 0;
        border-color: $tableRowBorderLowColor;
        border-bottom-color: $tableRowBorderColor;
        font-size: 12px;
        padding: 5px;
        padding-top: 8px;
        white-space: nowrap;
      }
      td:hover {
        background-color: $tableColumnBackgroundColorHover;
      }
      td:first-child {
        border-left-width: 1px;
      }
    }
  }
</style>
